export class LocationNotFoundError extends Error {
  constructor() {
    super('The the location with the given Id was not found')
  }
}
